import type { AuthUser } from '@/types/auth';

export const TOKEN_KEY = 'externo_token';
export const REFRESH_TOKEN_KEY = 'externo_refresh_token';
const USER_KEY = 'externo_user';

// "Zapamti me" bira gdje sesija živi: localStorage (preživi zatvaranje
// preglednika) ili sessionStorage (nestane kad se tab/prozor zatvori — obično
// ponašanje sessionStorage-a, ne treba ništa ručno brisati na zatvaranje).
const STORES = [sessionStorage, localStorage] as const;

const readFromEither = (key: string): string | null => {
  for (const store of STORES) {
    const value = store.getItem(key);
    if (value) return value;
  }
  return null;
};

// Sesija koja trenutno postoji "živi" u jednom od dva spremišta — osvježeni
// tokeni (refresh, promjena lozinke) moraju se upisati NATRAG u ISTO
// spremište, ne uvijek u localStorage, inače bi "zapamti me" prestao vrijediti
// nakon prvog tihog osvježavanja tokena.
const activeStore = (): Storage =>
  sessionStorage.getItem(REFRESH_TOKEN_KEY) ? sessionStorage : localStorage;

export const getAccessToken = (): string | null => readFromEither(TOKEN_KEY);
export const getRefreshToken = (): string | null => readFromEither(REFRESH_TOKEN_KEY);

export const getStoredUser = (): AuthUser | null => {
  try {
    const raw = readFromEither(USER_KEY);
    return raw ? (JSON.parse(raw) as AuthUser) : null;
  } catch {
    return null;
  }
};

export const startSession = (
  accessToken: string,
  refreshToken: string,
  user: AuthUser,
  remember: boolean
): void => {
  clearSession();
  const store = remember ? localStorage : sessionStorage;
  store.setItem(TOKEN_KEY, accessToken);
  store.setItem(REFRESH_TOKEN_KEY, refreshToken);
  store.setItem(USER_KEY, JSON.stringify(user));
};

export const updateTokens = (accessToken: string, refreshToken: string): void => {
  const store = activeStore();
  store.setItem(TOKEN_KEY, accessToken);
  store.setItem(REFRESH_TOKEN_KEY, refreshToken);
};

export const updateStoredUser = (user: AuthUser): void => {
  activeStore().setItem(USER_KEY, JSON.stringify(user));
};

export const clearSession = (): void => {
  for (const store of STORES) {
    store.removeItem(TOKEN_KEY);
    store.removeItem(REFRESH_TOKEN_KEY);
    store.removeItem(USER_KEY);
  }
};
